import { add, round, subtract } from 'vend-number'

/**
 * Max cash/card the register can collect against account balance while
 * pay-balance payments (e.g. ACH) are still in transit.
 *
 * Headline owing stays the full account balance; this subtracts in-transit
 * so merchants cannot re-collect that portion.
 */
export const getMaxPayableAmount = (
  accountBalance: number,
  inTransitAmount: number
): number => {
  const balance = Number.isFinite(accountBalance) ? accountBalance : 0
  const inTransit = Number.isFinite(inTransitAmount) ? inTransitAmount : 0
  return Math.max(0, Number(round(subtract(balance, inTransit), 2)))
}

/**
 * Sum finite in-transit amounts from independent sources (sale-tag ACH +
 * payment-request ACH). Undefined when no source reported an amount.
 * Do not take min of leftovers — these do not overlap in store.
 */
export const sumDefinedAmounts = (
  ...values: Array<number | undefined>
): number | undefined => {
  const defined = values.filter(
    (value): value is number => value !== undefined && Number.isFinite(value)
  )
  if (defined.length === 0) {
    return undefined
  }
  return Number(
    round(
      defined.reduce((sum, value) => add(sum, value), 0),
      2
    )
  )
}
